import { Collection, Linked } from '@type-r/models';
import { asCurrency, asTimelessDate, Flex, getAppHref, PageHeaderTile, PageTileField, PopoverValue, Toolbar } from 'lqx-react';
import * as React from 'react';
import { Payment, Reconciliation } from 'src/app/pages/inmatch/api';
import { CustomerSupplier } from '../../../../../../common/inmatch';
import { MatchedInvoices, UnfundedInvoices } from '../../matching/unreconciled/potential-matches';
import { useModel } from '@type-r/react';
import { IconButton, styled } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';

export const PaymentHeader = ({ payment, reconciliations, $dialog } : {
    payment : Payment,
    reconciliations: Collection<Reconciliation>,
    $dialog: Linked<boolean>
} ) => {

    const paymentModelCopy: Payment = useModel(Payment);

    React.useEffect(()=>{
        payment.matches.forEach(match => {
            paymentModelCopy.matches.remove(match);
        });
        reconciliations.forEach(reconciliation =>  {
            reconciliation.matches.forEach(match => {
                paymentModelCopy.matches.add(match)
            })
        });
    }, []);

    const unfundedMatches = paymentModelCopy.matches.filter(inv => !inv.invoiceId && !!inv.invoiceNumber);

    return (
        <PageHeaderTile
            title={ <CustomerSupplier customer={payment.customer}  supplier={payment.supplier} /> }
            returnLink={ getAppHref('/bank-transactions') }
            toolbar={
                <Toolbar>
                    <Flex grow />
                    { reconciliations && reconciliations.length ?
                        <IconButton aria-label="Attach" size="medium"
                            onClick={() => $dialog.true()}>
                            <AttachFileIcon />
                        </IconButton> 
                        : undefined
                    }
                </Toolbar>
            }
        >
            <PageTileField label="Amount">
                {asCurrency(payment.amount, payment.currency)}
            </PageTileField>
            <PageTileField label="Statement Date">
                { asTimelessDate( payment.statementDate ) }
            </PageTileField>
            <PageTileField label="Value Date">
                { asTimelessDate( payment.valueDate ) }
            </PageTileField>
            <PageTileField label="Invoices">
                <PopoverValue label={<LabelCount>{paymentModelCopy.matches.length}</LabelCount>}>
                    <MatchedInvoices matches={paymentModelCopy.matches} disabled showExport currency={payment.currency}/>
                    { 
                        unfundedMatches && unfundedMatches.length ? 
                            <UnfundedInvoices matches={ unfundedMatches } currency={payment.currency} remitanceAdviceId={payment.remittanceAdviceId} disabled />
                        : undefined 
                    }
                </PopoverValue>
            </PageTileField> 
        </PageHeaderTile>
    ) 
}

export const LabelCount = styled('span')({
    color: 'blue', 
    textDecoration: 'underline'
});
